export default __webpack_public_path__ + "static/media/class_xi_xii_engg_m.10247052.png";